export const getDeviceInfo = () => {
  const ua = navigator.userAgent;

  const platform_type = 'web';

  const device_type = /Mobi|Android|iPhone|iPad/i.test(ua)
    ? 'mobile'
    : 'desktop';

  let os_name = 'Unknown';
  let os_version = 'Unknown';

  // WINDOWS (Best possible mapping)
  if (/Windows NT/i.test(ua)) {
    os_name = 'Windows';

    if (ua.includes('Windows NT 10.0')) os_version = '10 / 11';
    else if (ua.includes('Windows NT 6.3')) os_version = '8.1';
    else if (ua.includes('Windows NT 6.2')) os_version = '8';
    else if (ua.includes('Windows NT 6.1')) os_version = '7';
    else if (ua.includes('Windows NT 6.0')) os_version = 'Vista';
    else if (ua.includes('Windows NT 5.1')) os_version = 'XP';
  }

  // ANDROID
  else if (/Android/i.test(ua)) {
    os_name = 'Android';
    os_version = ua.match(/Android ([0-9.]+)/)?.[1] || 'Unknown';
  }

  // iOS
  else if (/iPhone|iPad/i.test(ua)) {
    os_name = 'iOS';
    os_version = ua.match(/OS ([0-9_]+)/)?.[1]?.replace(/_/g, '.') || 'Unknown';
  }

  // macOS
  else if (/Mac OS X/i.test(ua)) {
    os_name = 'macOS';
    os_version = ua.match(/Mac OS X ([0-9_]+)/)?.[1]?.replace(/_/g, '.') || 'Unknown';
  }

  // Linux
  else if (/Linux/i.test(ua)) {
    os_name = 'Linux';
    os_version = 'Unknown';
  }

  return {
    platform_type,
    device_type,
    os_name,
    os_version
  };
};
